<template>
    <SlotsMain />
</template>

<script>
import SlotsMain from '@/components/slots/SlotsMain.vue';

export default {
    name: 'Slots',
    components: {
        SlotsMain
    },
    metaInfo: {
        title: 'Slots - Casino Games'
    }
}
</script>
